import { ESymbolCategory } from '@aqx-core/common/api/market';
import { EOrderState, EOrderType } from '@aqx-core/common/api/order';
import { IOption, IOptionPressable } from '@aqx-core/common/types/option';

export enum EDateRangeOption {
  ALL = 'ALL',
  LAST_7_DAYS = 'LAST_7_DAYS',
  LAST_30_DAYS = 'LAST_30_DAYS',
  LAST_90_DAYS = 'LAST_90_DAYS',
  THIS_YEAR = 'THIS_YEAR',
  LAST_YEAR = 'LAST_YEAR',
  CUSTOM = 'CUSTOM'
}

export enum ESortOption {
  LATEST = 'LATEST',
  OLDEST = 'OLDEST',
  A_Z = 'A_Z',
  Z_A = 'Z_A',
  PROFIT_LOSS_ASCENDING = 'PROFIT_LOSS_ASCENDING',
  PROFIT_LOSS_DESCENDING = 'PROFIT_LOSS_DESCENDING'
}

export type IFilterOrderType = EOrderType | 'ALL';

export type IFilterOrderState = EOrderState | 'ALL';

export interface IDateRangeOption extends IOptionPressable<EDateRangeOption> {
  from?: Date;
  to?: Date;
}
export interface IAssetsFilterFormValues {
  orderType?: IOption<IFilterOrderType>;
  orderState?: IOption<IFilterOrderState>;
  assetTypes?: ESymbolCategory[];
  dateRange?: IDateRangeOption;
  sortBy?: ESortOption;
}

export interface IAssetsFilterValues {
  orderType?: IFilterOrderType;
  orderState?: IFilterOrderState;
  assetTypes?: ESymbolCategory[];
  currentAssetType?: ESymbolCategory;
  dateRange?: Omit<IDateRangeOption, 'label' | 'testID'>;
  sortBy?: ESortOption;
}
